import React from "react";
import { Link } from "react-router-dom";

const HoverWidget = ({
  success,
  info,
  warning,
  danger,
  title,
  subTitle,
  stat,
  progress,
  progressInfo,
  progressSuccess,
  progressWarning,
  progressDanger,
  width = 0,
  text,
  link,
  linkText,
  onClick
}) => {
  let _classes = ["dev-widget"];
  let _progressClasses = ["progress-bar"];
  if (success) {
    _classes.push("dev-widget-success");
  }
  if (info) {
    _classes.push("dev-widget-info");
  }
  if (warning) {
    _classes.push("dev-widget-warning");
  }
  if (danger) {
    _classes.push("dev-widget-danger");
  }
  if (progressInfo) {
    _progressClasses.push("progress-bar-info");
  }
  if (progressWarning) {
    _progressClasses.push("progress-bar-warning");
  }
  if (progressSuccess) {
    _progressClasses.push("progress-bar-success");
  }
  if (progressDanger) {
    _progressClasses.push("progress-bar-danger");
  }

  return (
    <div class="dev-col">
      <div className={_classes.join(" ")}>
        <h2>{title}</h2>
        <p>{subTitle}</p>
        <div class="dev-stat">
          <span class="counter">{stat}</span>
        </div>
        {progress ? (
          <div class="progress progress-bar-xs">
            <div
              className={_progressClasses.join(" ")}
              role="progressbar"
              aria-valuenow={width}
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: `${width}%` }}
            />
          </div>
        ) : null}

        <p>{text}</p>

        {link ? (
          <Link to={link} class="dev-drop">
            {linkText} <span class="fa fa-angle-right pull-right" />
          </Link>
        ) : null}
        {onClick ? (
          <a onClick={onClick} class="dev-drop">
            {linkText} <span class="fa fa-angle-right pull-right" />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default HoverWidget;



// WEBPACK FOOTER //
// ./src/_components/UI/HoverWidget/index.js